import { SuSyApi } from '../../../api/susyApi';
import { Dispatch } from 'react';
import {
    ProjectSettingsAction,
    ProjectSettingsType,
} from '../../actionTypes/settings/projectSettings';
import {
    getInitialProjectTypeSettingsState,
    IProjectTypeSettings,
} from '../../types';
import { RootState } from '../..';
import { toast } from 'react-toastify';

const PROJECT_SETTINGS_INITIAL_STATE: IProjectTypeSettings =
    getInitialProjectTypeSettingsState();

export const updateProjectSettings =
    (settings: IProjectTypeSettings) =>
    async (dispatch: Dispatch<ProjectSettingsAction>) => {
        const response = await SuSyApi.put(
            '/settings/projectSettings',
            settings
        );

        dispatch({
            type: ProjectSettingsType.UPDATE_PROJECT_SETTINGS,
            payload: response.data,
        });
    };

export const createProjectSettings =
    (settings: IProjectTypeSettings) =>
    async (dispatch: Dispatch<ProjectSettingsAction>) => {
        const response = await SuSyApi.post(
            '/settings/projectSettings',
            settings
        );

        dispatch({
            type: ProjectSettingsType.CREATE_PROJECT_SETTINGS,
            payload: response.data,
        });
    };

export const getAllProjectSettings =
    () => async (dispatch: Dispatch<ProjectSettingsAction>) => {
        const response = await SuSyApi.get('/settings/projectSettings');

        dispatch({
            type: ProjectSettingsType.GET_PROJECT_SETTINGS,
            payload: response.data,
        });
    };

export const getVisibleProjectSettings =
    () => async (dispatch: Dispatch<ProjectSettingsAction>) => {
        const response = await SuSyApi.get('/settings/projectSettings/visible');

        dispatch({
            type: ProjectSettingsType.GET_PROJECT_SETTINGS,
            payload: response.data,
        });
    };

export const setCurrentProjectTypeSettings =
    (id: string | undefined, restrictedIntakeIds: string[]) =>
    async (
        dispatch: Dispatch<ProjectSettingsAction>,
        getState: () => RootState
    ) => {
        if (!id) {
            dispatch({
                type: ProjectSettingsType.SET_CURRENT_PROJECT_TYPE_SETTINGS,
                payload: {
                    projectSettings: PROJECT_SETTINGS_INITIAL_STATE,
                    restrictedIntakeIds: [],
                },
            });
            return;
        }

        const globalState = getState();

        const projectTypeSettings =
            globalState.projectSettings.projectSettings.find(
                (settings) => settings._id === id
            );

        const errorMessage =
            globalState.localization.localizationStrings.susy.admin
                .generalSettings.projectSettings.projectSettingsSubTub
                .settingCurrentProjectTypeSettingsError;

        if (!projectTypeSettings) {
            toast.warning(errorMessage);
            return;
        }

        dispatch({
            type: ProjectSettingsType.SET_CURRENT_PROJECT_TYPE_SETTINGS,
            payload: {
                projectSettings: projectTypeSettings,
                restrictedIntakeIds,
            },
        });
    };

export const deleteProjectSettings =
    (id: string) => async (dispatch: Dispatch<ProjectSettingsAction>) => {
        const response = await SuSyApi.delete(
            `/settings/projectSettings/${id}`
        );

        dispatch({
            type: ProjectSettingsType.DELETE_PROJECT_SETTINGS,
            payload: response.data,
        });
    };
